import { render, staticRenderFns } from "./RelatedPasswordSetting.vue?vue&type=template&id=2b4aab84&scoped=true&lang=pug"
import script from "./RelatedPasswordSetting.vue?vue&type=script&lang=js"
export * from "./RelatedPasswordSetting.vue?vue&type=script&lang=js"
import style0 from "./RelatedPasswordSetting.vue?vue&type=style&index=0&id=2b4aab84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4aab84",
  null
  
)

export default component.exports